// Seamless horizontal scrolling marquee.
// Add or remove items in DEFAULT_ITEMS below (or pass `items` prop), the loop
// stays visually seamless because the track renders the item sequence twice
// and animates translateX(0) → translateX(-50%) at a linear rate.
//
// 2026-02-14 fix v2: each "copy" now repeats the item sequence enough
// times to be wider than a typical desktop viewport, guaranteeing that
// the visible strip is always covered even mid-animation. Two-copy
// equal-width trick still handles the reset, but each copy is now
// large enough that at any translation phase the viewport is fully
// inhabited by rendered tokens.
const DEFAULT_ITEMS = [
  "TRACKED UK & EU DISPATCH",
  "THIRD-PARTY TESTED",
  "COA WITH EVERY ORDER",
];

// Base pixels per second, tune here to change scroll speed site-wide.
const PIXELS_PER_SECOND = 60;
// Approx px-width per rendered item (text + margins on both sides + star).
// Only used to keep speed constant as items are added; actual layout is CSS.
const APPROX_ITEM_PX = 260;
// Repeats per copy so the sequence is wider than a common desktop
// viewport (1920px). 3 repeats × 3 items × ~260px ≈ 2340px per copy.
const REPEATS_PER_COPY = 3;

export default function TopTicker({ items = DEFAULT_ITEMS }) {
  const trackLen = items.length * REPEATS_PER_COPY * APPROX_ITEM_PX;
  const duration = Math.max(20, Math.round(trackLen / PIXELS_PER_SECOND));

  const renderCopy = (key) => (
    <div className="flex shrink-0" key={key} data-testid={key}>
      {Array.from({ length: REPEATS_PER_COPY }).flatMap((_, rep) =>
        items.map((t, i) => (
          <span
            key={`${rep}-${i}`}
            className="flex items-center font-mono text-[11px] tracking-[0.22em] whitespace-nowrap"
          >
            <span className="mx-6">{t}</span>
            <span className="mx-6 text-brandblue">★</span>
          </span>
        ))
      )}
    </div>
  );

  return (
    <div className="w-full overflow-hidden bg-navy text-white" data-testid="top-ticker">
      <div
        className="marquee-track py-1.5 sm:py-2"
        style={{ "--marquee-duration": `${duration}s` }}
      >
        {renderCopy("ticker-copy-1")}
        {renderCopy("ticker-copy-2")}
      </div>
    </div>
  );
}
